import { AnalyticDimensions } from '@/analytics/types';
import { ProductEntity } from '@/product/types';

export const extractProductAnalyticDimensions = (product: Nullable<ProductEntity> | undefined): AnalyticDimensions => {
  if (!product) {
    return {};
  }

  return {
    id: product.id,
    b2bId: product.sellerId,
    b2bSid: product.b2bSid,
  };
};
